import React, { Component } from "react";

import { connect } from "react-redux";
import { fetchSkills } from "../../../../actions/skills.actions";
import ProfessionalSkills from "../components/ProfessionalSkills";
import { updateUserData } from "../../../../actions/user.actions";

class ProfessionalSkillsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStep: 1
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchSkills();
  }

  handleSubmit(data) {
    const filteredSkills = [];

    data.skills.forEach((isSkillSelected, index) => {
      if (isSkillSelected) {
        filteredSkills[index] = isSkillSelected;
      }
    });

    data.skills = filteredSkills;
    this.props.updateUserData(data, "/member/endorsements");
  }

  render() {
    return (
      <ProfessionalSkills
        onSubmit={this.handleSubmit}
        skills={this.props.skills}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    skills: state.skills.skills.data
  };
};

const mapDispatchToProps = dispatch => ({
  fetchSkills: () => dispatch(fetchSkills()),
  updateUserData: (user, redirect) => dispatch(updateUserData(user, redirect))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfessionalSkillsContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/professionalSkills/containers/ProfessionalSkillsContainer.js